import { useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { isAuthenticated, getTokens } from "../api/identity";

const RequireAuth: React.FC<{ children: React.ReactElement }> = ({
  children,
}) => {
  const navigate = useNavigate();

  useEffect(() => {
    const checkAuthentication = async () => {
      const tokens = getTokens();
      if (!tokens || !isAuthenticated()) {
        console.log("Not authenticated, redirecting to login");
        navigate("/login");
      }
    };

    checkAuthentication();
  }, [navigate]);

  return children;
};

export default RequireAuth;
